import { posKey } from '../../utills/meal-planer';

export const selectPositionById = (state, id) => {
    return state.mealPlaner.positions[posKey(id)];
};
